import { Navigate } from 'react-router-dom';
import { Card, CardBody, Col } from 'react-bootstrap';
import LogoBox from '../../components/LogoBox';
import PageMetaData from '../../components/PageTitle';
import { useAuth } from '../../context/AuthContext';
import LoginForm from './components/LoginForm';

const SignIn2 = () => {
  const { isAuthenticated } = useAuth();
  if (isAuthenticated) return <Navigate to="/dashboard" replace />;

  return (
    <>
      {/* <PageMetaData title="Login" /> */}

      <Col xl={5} className="mx-auto">
        <Card className="auth-card">
          <CardBody className="px-3 py-5">
            <LogoBox containerClassName="mx-auto mb-4 text-center auth-logo" />
            {/* <h2 className="fw-bold text-center fs-18">Sign In</h2> */}
            {/* <p className="text-muted tx */}
            <div className="px-4">
              <LoginForm />
            </div>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default SignIn2;
